import React from 'react';
import { Button, ButtonProps, Tooltip } from '@/components/ui';
import { usePermission } from './usePermission';
import { Module, Action } from '@/config/permission-matrix.config';

interface AuthButtonProps extends ButtonProps {
  module: Module;
  action: Action;
  resourceId?: string;
  behavior?: 'hide' | 'disable';
  permissionReason?: string; // Lý do cụ thể nếu bị chặn
}

/**
 * AuthButton - Component nút bấm nhận diện quyền hạn
 * Tuân thủ chuẩn Landscape: Ẩn (Hide) hoặc Vô hiệu hóa (Disable) kèm Tooltip
 */
export const AuthButton: React.FC<AuthButtonProps> = ({
  module,
  action,
  resourceId,
  behavior = 'hide',
  permissionReason,
  disabled,
  children,
  ...props
}) => {
  const { can, role } = usePermission();
  const hasPermission = can(module, action);

  if (!hasPermission && behavior === 'hide') {
    return null;
  }

  const buttonContent = (
    <Button
      {...props}
      disabled={disabled || !hasPermission}
    >
      {children}
    </Button>
  );

  if (!hasPermission && behavior === 'disable') {
    const reason = permissionReason || `Cấp bậc của bạn (${role}) không có quyền thực hiện hành động này.`;
    return (
      <Tooltip content={reason}>
        <span className="inline-block cursor-not-allowed">
          {buttonContent}
        </span>
      </Tooltip>
    );
  }

  return buttonContent;
};
